import { UserSliceDTO } from 'features/user/forms/UserEmployeeForm/types'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'

export const PUBLISHER_FRAGMENT: TypedDocumentNode<UserSliceDTO> = gql`
  fragment PublisherFragment on User {
    id
    email
    userWorkspaces {
      id
      role
    }
  }
`
